import Home from '@/views/Home.vue'
import CompanyHome from '@/views/CompanyHome.vue'

/*  Public Routes */
export default [
  {
    path: '/',
    name: 'home',
    meta: {
      layout: 'default',
      showHero: true
    },
    component: Home
  },
  {
    path: '/company-home',
    name: 'company-home',
    meta: {
      layout: 'jobs'
    },
    component: CompanyHome
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/Register.vue')
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/VerifyAnnouncement.vue')
  },
  {
    path: '/verify-email',
    name: 'VerifyEMail',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/VerifyEmail.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetActualPassword',
    meta: {
      layout: 'jobs',
      auth: false
    },
    component: () => import('@/views/auth/Reset.vue')
  },
  {
    path: '/help',
    name: 'Help',
    meta: {
      layout: 'jobs'
    },
    component: () => import('@/views/Help.vue')
  },
  {
    path: '/contact-us',
    name: 'ContactsForm',
    meta: {
      layout: 'default'
    },
    component: () => import('@/views/ContactForm.vue')
  },
  {
    path: '/jobs/offer/:id/:slug?/:province?',
    name: 'one-offer',
    meta: {
      name: 'main.routes.one-offer',
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/OneOffer.vue')
  },
  {
    path: '/jobs/company/:id/:slug?',
    name: 'company-page',
    meta: {
      name: 'main.routes.one-company',
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/CompanyPage.vue')
  },
  {
    path: '/jobs/search',
    name: 'search-offers',
    meta: {
      name: 'CV',
      layout: 'default',
    },
    component: () => import('@/views/SearchOffers.vue')
  },

  // Policies
  {
    path: '/policies/privacy',
    name: 'privacy-policy',
    meta: {
      name: 'CV',
      layout: 'default',
    },
    component: () => import('@/views/public/policies/Privacy')
  },
  {
    path: '/policies/cookies',
    name: 'cookies-policy',
    meta: {
      name: 'CV',
      layout: 'default',
    },
    component: () => import('@/views/public/policies/Cookies')
  },
  {
    path: '/policies/general-conditions',
    name: 'general-conditions',
    meta: {
      name: 'CV',
      layout: 'default',
    },
    component: () => import('@/views/public/policies/General')
  },
  {
    path: '/vip-services/recruitment',
    name: 'recruitment',
    meta: {
      layout: 'default',
    },
    component: () => import('@/views/public/Recruitment')
  },
  {
    path: '/vip-services/workwithus',
    name: 'workwithus',
    meta: {
      layout: 'fullwidth',
    },
    component: () => import('@/views/public/WorkWithUs')
  },

  /* NOT FOUND */
  {
    path: '*',
    name: 'not-found',
    meta: {
      layout: 'jobs'
    },
    component: () => import('@/views/NotFound.vue')
  }
]
